module.exports = "/_next/static/images/DefaultThumbnail2-04d5ec25bb17accc21dca9e2a9641288.png";